<template>
<div class="site-navbar row el-container">
  <div class="col s6 m12 yo-align-center ">
    <el-menu default-active="1"  mode="horizontal" :router="true" @select="handleSelect">
      <el-menu-item index="/home" class="">HOME</el-menu-item>
      <el-menu-item index="/loadpage/progetto/progetto" class="">IL PROGETTO</el-menu-item>
      <!-- <el-menu-item index="/loadpage/progetto/scheda" class="">SCHEDA DATI</el-menu-item>-->
      <el-menu-item index="/loadpage/progetto/working-group" class="">WORKING GROUP</el-menu-item>
      

      <el-menu-item index="/loadpage/centri/centri" class="">CENTRI ADERENTI</el-menu-item>
      <li class="el-menu-item"><a href="/network/registrazione" target="_blank">REGISTRAZIONE</a></li>
      <li class="el-menu-item"><a href="/network/login"  target="_blank">LOGIN</a></li>
    </el-menu> 
  </div>
</div>
</template>

<script>
export default {
  name: 'site-navbar',
  created () {
    console.log("Created Site-logged.vue")
  },
  methods: {
    handleSelect(key, keyPath) {
        if(keyPath=='/sezione/2/'){
            
        }
        else if(keyPath=='/page/f/4'){
           
        }
        else {
            
        }

        console.log()
        

    }
  }
}
</script>

<style>

/* SITE-NAVBAR */
.site-navbar{
  background: #7190AF;
}.site-navbar ul.el-menu{
  background: transparent !important;
  margin:0 auto !important;
}.site-navbar li, .site-navbar .el-submenu .el-submenu__title, .site-navbar .el-submenu.is-active .el-submenu__title, .site-navbar .el-submenu .el-submenu__icon-arrow{
  color:#182E4F !important;
  font-weight:bold;
  font-size:1.4rem;
  letter-spacing: -.6px;
  padding:0;
  text-align:center;
  line-height:52px !important;
  height:52px !important;
  border:none !important;
}.site-navbar .el-menu > .el-menu-item, .site-navbar .el-menu > .el-submenu{
  width: 16.60% !important;
  color:#182E4F !important;
  font-size:1.4rem;
  border-bottom:none !important;
  line-height:52px;
  height:52px;
}li.el-menu-item:last-child{
  margin:0;    
}.site-navbar .el-menu-item:hover,.site-navbar .el-menu-item:focus, .site-navbar .el-submenu:hover , .site-navbar .el-submenu:hover .el-submenu__title:hover{
  color:#fff !important;
  border-bottom:darkred;
  background-color: #182E4F !important;
}.site-navbar .el-submenu > .el-menu{
  width:100px !important;
}.site-navbar .el-submenu > .el-menu .el-menu-item{
  color:#fff;
  background-color: #182E4F !important;
  padding:0 10px;
  text-align:left;
  width: 100px !important;
  overflow:hidden;
  margin:0;
}.el-menu-item a{
  display:block;
}.el-menu--horizontal .el-submenu .el-submenu__icon-arrow{
  color:#182E4F !important;
}.el-menu--horizontal>.el-menu-item:hover, .el-menu--horizontal>.el-submenu.is-active .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
  border-bottom:none !important;
}.el-menu--horizontal .el-submenu>.el-menu{
  top:52px !important;
  padding:0 !important;
  border:none !important;
  border-radius: none !important;
}
</style>
